import { xlsxTypes } from "redux/reducers/gasMovDataXLSX/gasMovDataXLSXTypes";
import { PROYECT, api_post } from "services/api";
import { setSnackbar, startRequestComp, stopRequestComp } from "../search/searchActions";

const { SET_XLSX, SET_XML, SET_ALL_XML_STATUS, RESET_XLSX_STATE } = xlsxTypes;

const urlXlsx = `${process.env.REACT_APP_URL}${PROYECT}/xlsx_gas_movements`;
const urlXml = `${process.env.REACT_APP_URL}${PROYECT}/no_gn3_xml`;

export const setXlsxRow = (data) => {
  return { type: SET_XLSX, payload: data };
};

export const setXml = (file) => {
  return { type: SET_XML, payload: file };
};

export const setAllXmlStatus = (files) => {
  return { type: SET_ALL_XML_STATUS, payload: files };
};

export const resetState = () => {
  return { type: RESET_XLSX_STATE };
};

export const postFiles = (idStation, forms, token, close = null, fileType = "xlsx", type = "NoGN3") => {
  return async (dispatch) => {
    try {
      dispatch(startRequestComp("loadingXlsx"));
      const formData = new FormData();
      forms.map((form) => formData.append("files", form.file, form.fileName));
      if (fileType === "xml") formData.append("idStation", idStation);
      const url = fileType === "xml" ? `${urlXml}` : `${urlXlsx}?type=${type}`;
      const response = await api_post(`${url}`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          "Authorization": token
        }
      });

      if (fileType === "xml") {
        const newStatus = response;
        let errors = 0;
        const newXmlStatus = forms.map(file => {
          if (newStatus[file.fileName] !== "OK") errors += 1;
          return { ...file, status: newStatus[file.fileName] };
        });
        if (errors === forms.length) dispatch(setSnackbar("Documentos invalidos", "danger"));
        else if (errors) dispatch(setSnackbar("Algunos documentos son invalidos", "warning"));
        else dispatch(setSnackbar("Datos guardados con éxito", "success"));
        dispatch(setAllXmlStatus(newXmlStatus));
      }

      close && close();
      setTimeout(() => {
        if (fileType === "xlsx") {
          dispatch(setSnackbar(response.message, "success"));
          dispatch(resetState());
        }
        dispatch(stopRequestComp("loadingXlsx"));
      }, 400);

    } catch (error) {
      if (fileType === "xml") dispatch(setSnackbar("Error en los archivos"));
      else dispatch(setSnackbar(error));
      dispatch(stopRequestComp("loadingXlsx"));
    }
  };
};
